import { useCallback, useEffect, useRef, useState, type CSSProperties } from 'react';
import Tooltip from '@cloudscape-design/components/tooltip';

const BMC_SLUG = 'sramuschkat';

const TOOLTIP_TEXT =
  'Kleine freiwillige Aufmerksamkeitsgeste an den Entwickler über eine externe Spendenplattform – der Button-Name ist symbolisch, es geht nicht um einen echten Kauf von Kaffee.';

/** Fester Text-CTA (kein Fremd-Bild — zuverlässig bei ITP / Blockern). */
const linkStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.35em',
  padding: '8px 14px',
  backgroundColor: '#FFDD00',
  color: '#000000',
  border: '2px solid #000000',
  borderRadius: '8px',
  fontWeight: 600,
  textDecoration: 'none',
  fontSize: '14px',
  boxSizing: 'border-box',
  lineHeight: 1.25,
  maxWidth: '100%',
};

export default function BuyMeCoffeeButton() {
  const anchorRef = useRef<HTMLAnchorElement>(null);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const leaveTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearLeaveTimer = () => {
    if (leaveTimerRef.current) {
      clearTimeout(leaveTimerRef.current);
      leaveTimerRef.current = null;
    }
  };

  const showTooltip = () => {
    clearLeaveTimer();
    setTooltipOpen(true);
  };

  const scheduleHideTooltip = () => {
    clearLeaveTimer();
    leaveTimerRef.current = setTimeout(() => setTooltipOpen(false), 150);
  };

  useEffect(() => () => clearLeaveTimer(), []);

  const getTrack = useCallback(() => anchorRef.current, []);

  return (
    <span
      style={{ display: 'inline-flex', alignItems: 'center', maxWidth: '100%' }}
      onMouseEnter={showTooltip}
      onMouseLeave={scheduleHideTooltip}
      onFocus={showTooltip}
      onBlur={scheduleHideTooltip}
    >
      <a
        ref={anchorRef}
        href={`https://www.buymeacoffee.com/${BMC_SLUG}`}
        target="_blank"
        rel="noopener noreferrer"
        className="portfolio-wizard-bmc"
        style={linkStyle}
      >
        <span aria-hidden>☕</span>
        <span>Buy me a coffee</span>
      </a>
      {tooltipOpen && (
        <Tooltip content={TOOLTIP_TEXT} getTrack={getTrack} position="bottom" />
      )}
    </span>
  );
}
